import React from 'react';
import { LinkModel } from '../../models/globals';

interface IconLinkProps extends LinkModel {
    Icon: React.ElementType;
}

const IconLink: React.FC<IconLinkProps> = ({ Icon, name, url }) => {
    return (
        <a aria-label={name} href={url}>
            <Icon />
        </a>
    );
};

export { IconLink };
